<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
      <!-- 顶部区（导航+标题），ref 供表格高度计算 -->
      <div class="top-area" ref="topBox">
        <div class="order-navigation">
          <a
            class="text1"
            href="/#/catalogue"
          >{{L.home}}</a>
          <span class="line">/</span>
          <a
            class="text2"
            href="/#/opportunityProductList"
          >Opportunity Product List</a>
        </div>
        <div class="my-orders-title">
          <span class="title-text">Opportunity Product List</span>
          <!-- 与商机列表页对称：一键切回商机（表头）视图 -->
          <div class="btn-with-bg" @click="goOpportunityView">
            <span class="iconfont icon-switch">&#xe68a;</span>
            <span>Switch to Opportunity List View</span>
          </div>
        </div>
      </div>
      <!-- 表格上方通栏：左总数+过滤文字，右图标按钮组（照商机列表页 .btn-box，去掉 New：本页无新增/详情流程） -->
      <div class="btn-box" ref="btnBox">
        <div class="left-text">{{paginationObj.total}} items • {{filterText}}</div>
        <div class="btn-wrap">
          <div class="continuous-btn-no-bg">
            <div class="btn btn-icon" @click="handleRefresh">
              <span class="iconfont icon-refresh">&#xe611;</span>
            </div>
            <div class="btn btn-icon" @click="handleDownload">
              <span class="iconfont icon-download">&#xe61c;</span>
            </div>
            <div class="btn btn-icon" :class="{'active':showFilter}" @click="handleFilter">
              <span class="iconfont icon-filter">&#xe8d7;</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 表格 + 右侧可隐藏过滤浮层（照商机列表页：.table-wrap flex，.filter-wrap 与表格做兄弟、v-show 显隐） -->
      <div class="table-wrap">
        <el-table
          ref="table"
          class="cqm-table"
          :height="tableHeight"
          highlight-current-row
          size="mini"
          :data="list"
        >
          <el-table-column
            align="center"
            type="index"
            label=""
            width="50">
          </el-table-column>
          <el-table-column
            width="130"
            prop="oppNo"
            label="Opportunity No.">
            <template slot-scope="scope">
              <span class="click-btn" @click="goOpportunityDetail(scope.row)">{{ scope.row.oppNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="oppName"
            label="Opportunity Name">
          </el-table-column>
          <el-table-column
            width="120"
            prop="status"
            label="Status">
            <template slot-scope="scope">
              <span :class="getOppStatusColor(scope.row.status)">{{ getOppStatusText(scope.row.status) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            prop="productName"
            label="Product / NPI Description">
            <template slot-scope="scope">
              <span class="click-btn" @click="goProductDetail(scope.row)">{{ scope.row.productType=='NPI' ? scope.row.npiDesc : scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            prop="model"
            label="Model">
          </el-table-column>
          <el-table-column
            width="200"
            prop="buyingCustomerName"
            label="Ordering Customer">
          </el-table-column>
          <el-table-column
            width="200"
            prop="endCustomerName"
            label="End Customer">
          </el-table-column>
          <el-table-column
            width="180"
            prop="priceWithTax"
            label="Avg. Unit Price (Inc. Tax)">
            <template slot-scope="scope">
              <span>￥{{ scope.row.priceWithTax }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="annualQty"
            label="Est. Annual Qty">
          </el-table-column>
          <el-table-column
            width="190"
            prop="annualRevenue"
            label="Est. Annual Rev. (Excl. Tax)">
            <template slot-scope="scope">
              <span>￥{{ scope.row.annualRevenue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="210"
            prop="projectRevenue"
            label="Est. Proj Period Rev (Excl. Tax)">
            <template slot-scope="scope">
              <span>￥{{ scope.row.projectRevenue }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="deliveryStart"
            label="Est. Delivery Start">
            <template slot-scope="scope">
              <span>{{ formatDateNoTime(scope.row.deliveryStart) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="deliveryEnd"
            label="Est. Delivery End">
            <template slot-scope="scope">
              <span>{{ formatDateNoTime(scope.row.deliveryEnd) }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 右侧可隐藏过滤浮层（照商机列表页 .filter-wrap：title-close + content-scroll + save-btn；v-show 控制显隐）
             高度显式绑定 tableHeight：整体与表格齐高，内部 content-scroll(flex:1+overflow-y:auto) 才能在字段过多时单独滚动 -->
        <div class="filter-wrap" v-show="showFilter" :style="{height: tableHeight + 'px'}">
          <div class="title-close">
            <div class="left-text">Filters</div>
            <span class="iconfont icon-close" @click="closeFilter">&#xe65e;</span>
          </div>
          <div class="content-scroll" ref="filterWrap">
            <div class="search-wrap">
              <div class="search-text">Ordering Customer</div>
              <el-input class="search-inp" @keyup.enter.native="getList(2)" size="mini" v-model="search.buyingCustomerName"></el-input>
            </div>
            <div class="search-wrap">
              <div class="search-text">End Customer</div>
              <el-input class="search-inp" @keyup.enter.native="getList(2)" size="mini" v-model="search.endCustomerName"></el-input>
            </div>
            <div class="search-wrap">
              <div class="search-text">Status</div>
              <el-select size="mini" v-model="search.status" class="inp" placeholder="Please select" multiple clearable>
                <el-option
                  v-for="item in enumerate.oppStatus"
                  :key="item.code"
                  :label="item.nameEn"
                  :value="item.code">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="save-btn">
            <span class="search reset" @click="clearFilters">{{L.cleaFilters}}</span>
            <span class="search" @click="getList(2)">{{L.search}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页：控件一模一样照抄商机列表页 —— 裸 el-pagination（prev/pager/next + pager-count 5）；
         外层内套 .main-wrap，使分页条最大宽度与上方表格一致并居中对齐（不再贴视口左下角） -->
    <div class="page-wrap" ref="pageBox">
      <div class="main-wrap page-inner">
        <el-pagination
          :pager-count="5"
          @current-change="currentChange"
          :current-page="paginationObj.currentPage"
          :page-size="paginationObj.pageSize"
          layout="prev, pager, next"
          :total="paginationObj.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {postAction,downFilePost} from '@/api/tool'
import {api_opp_product_list_all,api_opp_download_product_list} from '@/api/api'
import selectMixin from '@/mixins/selectMixins'

export default {
  name:'OpportunityProductList',
  mixins:[selectMixin],
  data(){
    return {
      allLoading:false, //列表/下载 loading（显式声明，保证 v-loading 响应式生效）
      tableHeight:200, //表格固定高度，由 handleResize 动态计算（参考商机列表页）
      showFilter:false, //右侧过滤浮层是否显示（默认隐藏，点顶部过滤图标打开）
      search:{
        buyingCustomerName:'',
        endCustomerName:'',
        status:[] //多选，后端要数组
      },
      list:[] //列表数据
    }
  },
  computed:{
    /* 顶部通栏左侧的过滤状态文字（照商机列表页 filterText：无过滤显示 Not filtered，有则列出已过滤字段） */
    filterText(){
      let labels = {
        buyingCustomerName:'Ordering Customer',
        endCustomerName:'End Customer',
        status:'Status'
      }
      let parts = []
      for(let key in this.search){
        let value = this.search[key]
        //多选字段是数组：空数组 [] 也是真值，须按长度判断是否已过滤；其余标量字段按原逻辑
        let hasValue = Array.isArray(value) ? value.length>0 : (value || value===0)
        if(hasValue){
          let label = '【'+labels[key]+'】'
          if(parts.indexOf(label)===-1){ parts.push(label) }
        }
      }
      return parts.length>0 ? 'Filtered by'+parts.join('') : 'Not filtered'
    }
  },
  methods:{
    /* 计算并固定表格高度：以表格“实际渲染的顶部位置”为基准，视口高 − 表格顶 − 底部分页。
       顶部用实测(getBoundingClientRect)：吸顶头 .head-wrap 里 logo 是异步加载的图片，mounted 时常还没撑开高度，
       累加会偏小 → 表格算得过高 → 底部横向滚动条被固定分页条(.page-wrap)遮住。头部高度还会随 logo 图片与
       用户信息/权限菜单/语言包等异步数据到位而变(XHR 不触发 window load)，故另用 observeHeadResize() 的 ResizeObserver 兜住。 */
    handleResize(){
      this.$nextTick(()=>{
        if(!this.$refs.table){ return }
        let tableEl = this.$refs.table.$el
        let pageH = this.$refs.pageBox ? this.$refs.pageBox.offsetHeight : 0
        //表格顶部到文档顶部的实际距离(rect.top 是视口相对值，+pageYOffset 转为文档相对，免受当前滚动位置影响)
        let top = tableEl.getBoundingClientRect().top + window.pageYOffset
        let h = window.innerHeight - top - pageH
        this.tableHeight = h > 200 ? h : 200
        this.$refs.table.doLayout()
      })
    },
    /* 用 ResizeObserver 盯住吸顶头(.head-wrap)与顶部区(topBox)：二者高度会随 logo 图片、用户信息/权限菜单/语言包等
       异步数据到位而改变，而这些 XHR 不触发 window load，只靠 resize/load 会在头部最终长高前就定死表格高度。
       尺寸一变即重算即可始终贴合。ResizeObserver 不可用时静默降级(仍有 resize/load 兜底)。 */
    observeHeadResize(){
      if(typeof ResizeObserver === 'undefined'){ return }
      let targets = [document.querySelector('.head-wrap'), this.$refs.topBox].filter(Boolean)
      if(!targets.length){ return }
      this.headResizeObserver = new ResizeObserver(()=>{ this.handleResize() })
      targets.forEach(el=>this.headResizeObserver.observe(el))
    },
    /* 切回商机（表头）列表视图 */
    goOpportunityView(){
      this.$router.push({ name:'Opportunity' })
    },
    /* 点击 Opportunity No.：进入对应商机详情页(编辑态，id=oppNo，默认停在 General Information) */
    goOpportunityDetail(row){
      this.$router.push({ name:'OpportunityDetail', params:{ id: row.oppNo } })
    },
    /* 点击 Product / NPI Description：进入对应商机详情页并直接打开该产品的详情页签。
       详情页以 opportunityLineId 为页签 key，query.tab 带上它即可在详情加载完后由 restoreProductTabFromRoute 自动复原到该产品。
       若该行没有 opportunityLineId(异常数据)，则不带 query.tab，退化为只进详情页。 */
    goProductDetail(row){
      let query = {}
      if(row.opportunityLineId){
        query.tab = String(row.opportunityLineId)
      }
      this.$router.push({ name:'OpportunityDetail', params:{ id: row.oppNo }, query })
    },
    /* 下载（导出）当前过滤条件下的产品列表，走独立导出接口 api_opp_download_product_list(/api/opportunity/productExport) */
    handleDownload(){
      this.allLoading=true
      downFilePost(api_opp_download_product_list,this.search).then(res=>{
        this.allLoading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 获取列表,如果是2的话，从第一页开始 */
    getList(flag=1){
      if(flag==2){
        this.paginationObj.currentPage=1
      }
      let params = {
        pageNo:this.paginationObj.currentPage,
        pageSize:this.paginationObj.pageSize,
        ...this.search
      }
      this.allLoading=true
      postAction(api_opp_product_list_all,params).then(res=>{
        this.allLoading=false
        this.paginationObj.total=Number(res.total)
        this.list=res.list || []
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 打开右侧过滤浮层；表格宽度随之变窄，需 doLayout 重排 */
    handleFilter(){
      this.showFilter=true
      this.$nextTick(()=>{ if(this.$refs.table){ this.$refs.table.doLayout() } })
    },
    /* 关闭右侧过滤浮层 */
    closeFilter(){
      this.showFilter=false
      this.$nextTick(()=>{ if(this.$refs.table){ this.$refs.table.doLayout() } })
    },
    /* 刷新列表 */
    handleRefresh(){
      this.getList()
    },
    /* 重置搜索条件并且直接请求数据（重置后保持过滤浮层打开） */
    clearFilters(){
      this.search={
        buyingCustomerName:'',
        endCustomerName:'',
        status:[] //多选，重置为空数组
      }
      this.showFilter=true
      this.getList(2)
    }
  },
  mounted(){
    this.getList(2)
    this.getOppSelect()
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    //头部 logo 图片/字体异步加载完成后重算高度：否则首次刷新时 handleResize 量到的头部偏矮，表格会过高、底部滚动条被分页条遮住
    window.addEventListener('load', this.handleResize)
    //头部高度还会随用户信息/权限菜单/语言包等异步 XHR 数据到位而变(不触发 load)，用 ResizeObserver 兜住这类变化
    this.observeHeadResize()
  },
  beforeDestroy(){
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('load', this.handleResize)
    if(this.headResizeObserver){
      this.headResizeObserver.disconnect()
      this.headResizeObserver = null
    }
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>
